export const documentsEndpoints = {
  insertRequestDocument: { method: 'post', path: '/request/insert' },
  getRequestDocuments: { method: 'get', path: '/request/{requestId}/documents' },
  classifyRequestDocumentUpload: { method: 'post', path: '/upload-classifications/classify' },
  getRequestUploadClassifications: { method: 'get', path: '/upload-classifications' },
  reClassifyRequestDocumentUpload: { method: 'post', path: '/upload-classifications/re-classify' },
  getRequestEsignDocuments: { method: 'get', path: '/request/{requestId}/esign-documents' },
  updateRequestDocument: { method: 'post', path: '/request/update' },
  deleteRequestDocument: { method: 'post', path: '/request/delete' },
  insertGlobalDocument: { method: 'post', path: '/global/insert' },
  updateGlobalDocument: { method: 'post', path: '/global/update' },
  getGlobalDocument: { method: 'get', path: '/global/{id}' },
  getSupplierDocuments: { method: 'get', path: '/supplier/{organisationSupplierId}/documents' },
  listDocumentsV2: { method: 'post', path: '/global/paginated/v2' },
  deleteGlobalDocument: { method: 'post', path: '/global/delete' },
  getDocumentTypes: { method: 'get', path: '/document-types' },
  insertDocumentType: { method: 'post', path: '/types/insert' },
  deleteDocumentType: { method: 'post', path: '/types/delete/{id}' },
  updateDocumentType: { method: 'post', path: '/types/update/{id}' },
  listDocumentTypes: { method: 'get', path: '/types' },
  getDocumentType: { method: 'get', path: '/types/{id}' },
  getDocumentTypePlaybook: { method: 'get', path: '/types/{id}/playbook' },
  listDocumentTypePlaybooks: { method: 'get', path: '/types/playbooks' },
  duplicateDocumentType: { method: 'post', path: '/types/{id}/duplicate' },
  getSupplierRequestDocuments: { method: 'get', path: '/request/{requestId}/documents/supplier' },
  listBulkDocumentsUploads: { method: 'get', path: '/bulk/list' },
  triggerDocumentsBulkUpload: { method: 'post', path: '/bulk/trigger' },
  extractDocumentsToFormFeedback: { method: 'post', path: '/extract-to-form-feedback' },
  getSignedUrl: { method: 'get', path: '/signed-url' },
  createPolicy: { method: 'post', path: '/policies' },
  createPolicyVersion: { method: 'post', path: '/policies/{policyId}/versions' },
  listPolicies: { method: 'get', path: '/policies' },
  searchPolicyContent: { method: 'post', path: '/policies/search' },
  searchRequestDocumentContent: { method: 'post', path: '/request/search' },
} as const
